import useAppSelector from "hooks/useAppSelector"
import { selectActiveEmployeeByEmployeeId } from "store/Employee/detail.slice"
import Modal from "components/Modal"
import { useContext } from "react"
import EmployeeRetainContext, { EmployeeRetainContextProps } from "./CreateScheduleRetainContext"
import { Table2 } from "components/index"

interface Props {
	open: boolean
	modalHandler: (open: boolean) => void
}

const columns = [
	{ label: "Pin", key: "pin", className: "text-left" },
	{ label: "Client Pin", key: "clientPin", className: "text-left" },
	{ label: "First Name", key: "firstName", className: "text-left" },
	{ label: "Last Name", key: "lastName", className: "text-left" },
	{ label: "Short Name", key: "shortName", className: "text-left" },
	{ label: "Username", key: "userName", className: "text-left" },
	{ label: "Type", key: "type", className: "text-left" },
	{ label: "Address Line 1", key: "addressLine1", className: "text-left" },
	{ label: "Address Line 2", key: "addressLine2", className: "text-left" },
	{ label: "City", key: "city", className: "text-left" },
	{ label: "Postal Code", key: "postalCode", className: "text-left" },
	{ label: "Email", key: "email", className: "text-left" },
	{ label: "Mobile", key: "mobile", className: "text-left" },
	{ label: "Telephone", key: "telephone", className: "text-left" },
]

const ShowEmployeeDetailModal: React.FC<Props> = ({ open = false, modalHandler = () => undefined }) => {
	const { createScheduleModalData } = useContext(EmployeeRetainContext) as EmployeeRetainContextProps

	const selectedEmployeeDetails =
		useAppSelector(selectActiveEmployeeByEmployeeId(createScheduleModalData?.employee ?? "")) ?? null

	if (!selectedEmployeeDetails) return null

	return (
		<Modal
			open={open}
			title={<div className="font-semi p-2 text-center text-lg font-semibold">Employee Details</div>}
			modalHandler={modalHandler}
			goBack={true}
		>
			{<Table2 columns={columns} rows={[selectedEmployeeDetails]} />}
		</Modal>
	)
}

export default ShowEmployeeDetailModal
